<template>
    <div id="footerMenu" class="dd-m-menu dd-m-menu--footer">
        <nav class="dd-m-menu__container">
            <content-menu :menuItems="menuItems"></content-menu>
        </nav>
    </div>
</template>
<script>
    import ContentMenu from "./content-menu";
    import Categories from "./categories";
    
	import MenuService from "../../providers/api/menu-service";

    const menuService = new MenuService();

    export default {
        name: 'footer-menu',
        components: {ContentMenu, Categories},
        props: ['myAccount', 'sitemap'],
        data: () => {
            return {
                lang: '',
                menuItems: [],
                isLoading: false
            }
        },
        
        mounted() {
        	this.isLoading = true;
        	menuService.getFooterMenu().then((d)=>{
        		this.isLoading = false;
        		this.menuItems = d.data.data;
        	}).catch((e)=>{
        		console.error(e);
        		alert("catch");
        	});
            this.lang = language !== 'en' ? '/' + language : '';
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/header/footer-menu.vue